module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-26.52b9b93b.png";